import { PlusIcon } from "lucide-react"

import { Theme, useTheme } from "@/components/theme/themeProvider"
import { Button } from "@/components/ui/baseUi/button"
import { SidebarGroup } from "@/components/ui/layout/menuSidebar/sidebar"
import { Text } from "@/components/ui/baseUi/text"
import { word } from "@/modules/core/utils/i18n"
import { Path } from "@/modules/navigation/routes"
import { useNavigate } from "react-router"

export function NavCreateBox({ className }: { className?: string }) {
  const navigate = useNavigate()
  const { setTheme } = useTheme()

  const onCreateBox = () => {
    setTheme(Theme.OwnerDark)
    setTimeout(() => void navigate(Path.CreateBox), 100)
  }

  return (
    <SidebarGroup className={className}>
      <div className="mx-6 mt-1 mb-2.5 flex flex-col items-center gap-1 rounded-2xl bg-neutral-100 px-2 py-4">
        <Text fontStyle="BL" className="text-center">
          {word("menu.owner.title")}
        </Text>
        <Text fontStyle="BM" className="text-center text-neutral-600">
          {word("menu.owner.description")}
        </Text>
        <Button
          className="transition-duration-150 mt-4 flex cursor-pointer rounded-full bg-purple-500 p-2 transition-all hover:bg-purple-600"
          onClick={onCreateBox}
          size="iconMd"
        >
          <PlusIcon className="text-white" />
        </Button>
      </div>
    </SidebarGroup>
  )
}
